// src/pages/EmpList.jsx
import React, { useEffect, useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import AppConst from '../apis/appconst';
import NewEmp from '../models/NewEmp';
import DelBox from '../comps/DelBox';
import { toast } from 'react-toastify';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Swal from 'sweetalert2'; // <- SweetAlert2 import

const downloadCsv = (rows = [], filename = 'employees.csv') => {
  if (!rows || rows.length === 0) return;
  const keys = Object.keys(rows[0]);
  const csv = [
    keys.join(','),
    ...rows.map(r => keys.map(k => {
      const val = r[k] === null || r[k] === undefined ? '' : String(r[k]).replace(/"/g, '""');
      return `"${val}"`;
    }).join(','))
  ].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
const formatDateTime = (input) => {
    if (!input) return '-';
  
    // If input looks like "YYYY-MM-DD" or "YYYY-MM-DD HH:MM:SS" or ISO
    let dt;
    // if input is already a Date object:
    if (input instanceof Date && !isNaN(input)) {
      dt = input;
    } else {
      // normalize: if only date (YYYY-MM-DD) then append time part as midnight
      const plainDateMatch = /^\d{4}-\d{2}-\d{2}$/;
      try {
        if (plainDateMatch.test(input)) {
          dt = new Date(input + 'T00:00:00'); // treat as local midnight
        } else {
          // let JS parse ISO or 'YYYY-MM-DD HH:MM:SS' (replace space with T for safer parse)
          const candidate = String(input).trim().replace(' ', 'T');
          dt = new Date(candidate);
        }
        if (isNaN(dt)) return '-';
      } catch (e) {
        return '-';
      }
    }
  
    // build components
    const day = dt.getDate().toString().padStart(2, '0');
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const month = monthNames[dt.getMonth()];
    const year = dt.getFullYear();
  
    // time part
    const hours = dt.getHours();
    const minutes = dt.getMinutes().toString().padStart(2, '0');
    const isMidnightOnly = (hours === 0 && minutes === '00' && String(input).length <= 10 && /^\d{4}-\d{2}-\d{2}$/.test(String(input)));
  
    if (isMidnightOnly) {
      // user provided only date (YYYY-MM-DD) -> show date only
      return `${day} ${month} ${year}`;
    }
  
    // 12-hour format with AM/PM
    const h12 = (hours % 12) === 0 ? 12 : (hours % 12);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    return `${day} ${month} ${year} ${h12}:${minutes} ${ampm}`;
  };
// ExpenseModal component (create + edit)
const ExpenseModal = ({ show, item, onClose, onSaved }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    expenses: '',
    purpose: '',
    amount: '',
    expenses_by_name: '',
    expenses_by_mobile: '',
    date: (new Date()).toISOString().slice(0, 10) // YYYY-MM-DD default today
  });


// format date/time to "20 Oct 2025 12:45 PM" or "20 Oct 2025" if no time

  

  // When modal opens or item changes populate the form
  useEffect(() => {
    if (show) {
      if (item && typeof item === 'object') {
        setForm({
          expenses: item.expenses || '',
          purpose: item.purpose || '',
          amount: item.amount !== undefined ? item.amount : '',
          expenses_by_name: item.expenses_by_name || '',
          expenses_by_mobile: item.expenses_by_mobile || '',
          date: item.date ? (item.date.split(' ')[0]) : (new Date()).toISOString().slice(0, 10)
        });
      } else {
        setForm({
          expenses: '',
          purpose: '',
          amount: '',
          expenses_by_name: '',
          expenses_by_mobile: '',
          date: (new Date()).toISOString().slice(0, 10)
        });
      }
    }
  }, [show, item]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.expenses || form.amount === '' || form.amount === null) {
      toast.info('Please enter expense name and amount.');
      return;
    }

    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('expenses', form.expenses);
      fd.append('purpose', form.purpose);
      fd.append('amount', form.amount);
      fd.append('expenses_by_name', form.expenses_by_name);
      fd.append('expenses_by_mobile', form.expenses_by_mobile);
      fd.append('date', form.date);

      // if editing, include id
      if (item && item.id) {
        fd.append('id', item.id + '');
      }

      const res = await axios.post(AppConst.BASE_URL + (AppConst.addExpenseUrl || '/addExpense'), fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (res.data && res.data.status) {
        toast.success(item && item.id ? 'Expense updated' : 'Expense added');
        onSaved && onSaved(true);
        onClose && onClose();
      } else {
        toast.error(res.data?.error || 'Failed to save expense');
      }
    } catch (err) {
      console.error('add/edit expense error', err);
      toast.error('Failed to save expense');
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.4)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <form onSubmit={handleSubmit} className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{item && item.id ? 'Edit Expense' : 'Add Expense'}</h5>
            <button type="button" className="btn-close" onClick={() => onClose && onClose()}></button>
          </div>
          <div className="modal-body">
            <div className="mb-2">
              <label className="form-label">Expenses Name</label>
              <input name="expenses" value={form.expenses} onChange={handleChange} className="form-control" required />
            </div>

            <div className="mb-2">
              <label className="form-label">Purpose</label>
              <input name="purpose" value={form.purpose} onChange={handleChange} className="form-control" />
            </div>

            <div className="mb-2">
              <label className="form-label">Amount</label>
              <input name="amount" value={form.amount} onChange={handleChange} className="form-control" type="number" step="0.01" required />
            </div>

            <div className="mb-2">
              <label className="form-label">Expenses By Name</label>
              <input name="expenses_by_name" value={form.expenses_by_name} onChange={handleChange} className="form-control" />
            </div>

            <div className="mb-2">
              <label className="form-label">Expenses By Mobile</label>
              <input name="expenses_by_mobile" value={form.expenses_by_mobile} onChange={handleChange} className="form-control" />
            </div>

            <div className="mb-2">
              <label className="form-label">Date</label>
              <input name="date" value={form.date} onChange={handleChange} className="form-control" type="date" />
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={() => onClose && onClose()} disabled={loading}>Close</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : (item && item.id ? 'Update Expense' : 'Save Expense')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const Expense = () => {
 // helper to get YYYY-MM-DD today
const todayIso = (new Date()).toISOString().slice(0, 10);
const [formData, setFormData] = useState({
  l1: [],
  search_key: '',
  page_no: 0,
  from: todayIso,
  to: todayIso
});


  const [departments, setDepartments] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [editItem, setEditItem] = useState(null);

  // NEW: modal visibility state for NewEmp and ExpenseModal separately
  const [showModal, setShowModal] = useState(false); // existing NewEmp modal
  const [showExpenseModal, setShowExpenseModal] = useState(false); // new ExpenseModal
  const [editExpense, setEditExpense] = useState(null); // row to edit in ExpenseModal

  // load roles
  const fetchRoles = async () => {
    try {
      const res = await axios.get(AppConst.BASE_URL + AppConst.GetAllRole);
      if (res.data && res.data.status) setDepartments(res.data.list || []);
    } catch (err) {
      console.error('fetchRoles error', err);
      toast.error('Error fetching roles');
    }
  };

  // load expenses (list)
  // load expenses (list) — replace your existing loadUsers with this
const loadUsers = async (overrides = {}) => {
  try {
    // read current state, allow overrides (useful for immediate Clear action)
    const fromVal = (overrides.from ?? formData.from ?? '').toString().trim();
    const toVal   = (overrides.to   ?? formData.to   ?? '').toString().trim();

    // validate date range if both provided
    if (fromVal && toVal) {
      const fromDate = new Date(fromVal);
      const toDate = new Date(toVal);
      if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
        toast.error('Invalid From/To date');
        return;
      }
      if (fromDate > toDate) {
        toast.error('From date cannot be after To date');
        return;
      }
    }

    const fd = new FormData();
    fd.append('search_key', formData.search_key || '');
    fd.append('page_no', (formData.page_no || 0) + '');

    // send inclusive datetimes so backend can filter full day
    if (fromVal) fd.append('from', `${fromVal} 00:00:00`);
    if (toVal)   fd.append('to',   `${toVal} 23:59:59`);

    const res = await axios.post(AppConst.BASE_URL + AppConst.getExpensesListUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    if (res.data && res.data.status) {
      setFormData(prev => ({ ...prev, l1: Array.isArray(res.data.records) ? res.data.records : [] }));
    } else {
      setFormData(prev => ({ ...prev, l1: [] }));
    }
  } catch (err) {
    console.error('loadUsers error', err);
    toast.error('Failed to load expenses');
    setFormData(prev => ({ ...prev, l1: [] }));
  }
};


  useEffect(() => {
    const stored = sessionStorage.getItem('ldata');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setIsAdmin(parsed?.role_id === 1 || parsed?.role_id === '1');
      } catch (e) { /* ignore */ }
    }
    fetchRoles();
    loadUsers();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // reload when search or page changes
    loadUsers();
    // eslint-disable-next-line
  }, [formData.search_key, formData.page_no]);

  const getRoleNameById = (id) => {
    if (!id) return 'Unknown Role';
    const r = departments.find(d => String(d.id) === String(id));
    return r ? r.role_name : 'Unknown Role';
  };

  // OPEN NewEmp modal (existing)
  const openAddModal = () => {
    setEditItem(null);
    setShowModal(true);
    const el = document.getElementById('addbt453');
    if (el) el.click();
  };

  // OPEN edit in NewEmp (existing)
  const handleEdit = (row) => {
    setEditItem(row);
    setShowModal(true);
    const el = document.getElementById('addbt453');
    if (el) el.click();
  };

  // When adding expense via new ExpenseModal, open that:
  const openAddExpenseModal = () => {
    setEditExpense(null);
    setShowExpenseModal(true);
  };

  // When editing an expense row, open ExpenseModal populated with that row
  const handleEditExpense = (row) => {
    setEditExpense(row);
    setShowExpenseModal(true);
  };

  // SweetAlert2 delete confirmation
 // SweetAlert2 delete confirmation (fixed: send 'id' param expected by backend)
const handleDelete = async (row) => {
    if (!isAdmin) {
      toast.error('Only admin can delete.');
      return;
    }
  
    const result = await Swal.fire({
      title: `Delete ${row.expenses || 'this expense'}?`,
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    });
  
    if (!result.isConfirmed) return;
  
    try {
      const fd = new FormData();
      // Backend expects "id"
      fd.append('id', (row.id ?? row.ID ?? row.expense_id ?? '').toString());
  
      // optional: quick client-side sanity-check
      if (!fd.get('id')) {
        toast.error('Missing id for delete');
        return;
      }
  
      const res = await axios.post(AppConst.BASE_URL + AppConst.delExpenseUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
  
      // log for debugging if needed
      // console.log('del response', res.data);
  
      if (res.data && res.data.status) {
        toast.success('Deleted');
        await loadUsers();
      } else {
        // surfacing backend message if any
        const msg = res.data?.success || res.data?.error || 'Delete failed';
        toast.error(msg);
        console.error('Delete failed response:', res.data);
      }
    } catch (err) {
      console.error('delete error', err);
      toast.error('Delete failed');
    }
  };
  

  // PDF export (Expenses)
  const exportPdf = () => {
    const rows = filteredRows;
    const doc = new jsPDF('p', 'pt', 'a4');
    doc.setFontSize(14);
    doc.text('Expenses List', 40, 40);

    const head = [['Sl. No.', 'Expenses Name', 'Purpose', 'Amount', 'Expenses By Name/Mobile', 'Date']];
    const body = rows.map((r, idx) => {
      const name = r.expenses || '';
      const purpose = r.purpose || '';
      const amount = r.amount || '';
      const by = `${r.expenses_by_name || ''} ${r.expenses_by_mobile ? '/' + r.expenses_by_mobile : ''}`;
      const date = r.date || '';
      return [String(idx + 1), name, purpose, amount, by, date];
    });

    autoTable(doc, {
      startY: 60,
      head,
      body,
      styles: { fontSize: 10, cellPadding: 4 },
      headStyles: { fillColor: [215, 100, 34] },
      margin: { left: 40, right: 40 },
      theme: 'grid',
    });

    doc.save(`expenses_${Date.now()}.pdf`);
  };

  // client-side filtered rows
  const filteredRows = useMemo(() => {
    const s = (formData.search_key || '').trim().toLowerCase();
    if (!s) return formData.l1 || [];
    return (formData.l1 || []).filter(r =>
      (r.expenses || '').toString().toLowerCase().includes(s) ||
      (r.purpose || '').toString().toLowerCase().includes(s) ||
      (r.amount || '').toString().toLowerCase().includes(s) ||
      (`${r.expenses_by_name || ''} ${r.expenses_by_mobile || ''}`.toLowerCase().includes(s)) ||
      (r.date || '').toString().toLowerCase().includes(s)
    );
  }, [formData.l1, formData.search_key]);

  // columns adapted for expenses
  const columns = useMemo(() => ([
    {
      name: 'Sl. No.',
      selector: (row, idx) => idx + 1,
      width: '80px',
    },
    { name: 'Expenses Name', selector: row => row.expenses || '', sortable: true, grow: 1 },
    { name: 'Purpose', selector: row => row.purpose || '', sortable: true, width: '180px' },
    { name: 'Amount', selector: row => row.amount || '', sortable: true, width: '120px' },
    { name: 'Expenses By Name/Mobile', selector: row => `${row.expenses_by_name || ''} ${row.expenses_by_mobile ? '/' + row.expenses_by_mobile : ''}` || '', width: '200px' },
    { 
        name: 'Date', 
        selector: row => formatDateTime(row.date || row.created_at || ''), 
        width: '200px',
        sortable: true,
        // if you want correct sorting by date (not string), use:
        sortFunction: (a, b) => {
          const pa = a.date ? new Date(String(a.date).replace(' ', 'T')) : new Date(0);
          const pb = b.date ? new Date(String(b.date).replace(' ', 'T')) : new Date(0);
          return pa - pb;
        }
      },
      
    {
      name: 'Action',
      cell: row => (
        <div style={{ display: 'flex', gap: 8 }}>
          {/* Edit should open the ExpenseModal (not NewEmp) */}
          <button className="btn btn-sm btn-outline-primary" onClick={() => handleEditExpense(row)} disabled={!isAdmin} style={{ opacity: !isAdmin ? 0.5 : 1 }}>
            Edit
          </button>
          <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(row)} disabled={!isAdmin} style={{ opacity: !isAdmin ? 0.5 : 1 }}>
            Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '170px'
    }
  ]), [departments, isAdmin]);

  const customStyles = {
    headCells: { style: { backgroundColor: '#f1f5fb', color: '#405189', fontSize: '14px', fontWeight: '700' } },
    rows: { style: { minHeight: '56px' } },
    cells: { style: { paddingLeft: '12px', paddingRight: '12px' } }
  };

  // Callback when NewEmp closes/finishes adding/updating
  const onNewEmpClose = (refresh = false) => {
    setShowModal(false);
    setEditItem(null);
    if (refresh) loadUsers();
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="card" id="orderList">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-0">Expenses</h5>
            <div>
              <button className="btn btn-success me-2" onClick={openAddExpenseModal}>
                <i className="ri-add-line align-bottom me-1" /> Add Expense
              </button>

              <button className="btn btn-outline-secondary me-2" onClick={() => downloadCsv(filteredRows, 'expenses.csv')}>Export CSV</button>
              <button className="btn btn-outline-primary" onClick={exportPdf}>Export PDF</button>
            </div>
          </div>

          <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                    <div className="col-md-2">
                      <label className="form-label">From</label>
                      <input className="form-control" type="date" name="from"
  onChange={(e) => {
    const v = e.target.value;
    setFormData(prev => ({ ...prev, from: v, page_no: 0 }));
    // small delay to allow state update then fetch
    setTimeout(() => loadUsers({ from: v, to: formData.to }), 80);
  }}
  value={formData.from} />

                    </div>
                    <div className="col-md-2">
                      <label className="form-label">To</label>
                      <input className="form-control" type="date" name="to"
  onChange={(e) => {
    const v = e.target.value;
    setFormData(prev => ({ ...prev, to: v, page_no: 0 }));
    setTimeout(() => loadUsers({ from: formData.from, to: v }), 80);
  }}
  value={formData.to} />

                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Search</label>
                      <div className="search-box" style={{ display: "flex" }}>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" onClick={() => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const todayStr = `${yyyy}-${mm}-${dd}`;

  // Update UI immediately and reset page
  setFormData(prev => ({ ...prev, search_key: "", from: todayStr, to: todayStr, page_no: 0 }));

  // Fetch list for today immediately (pass overrides so we don't rely on state lag)
  setTimeout(() => loadUsers({ from: todayStr, to: todayStr }), 80);
}} className="btn btn-info">Clear</button>



                      </div>
                    </div>
                    <div className="col-md-3"></div>
                    <div className="col-md-3" style={{ textAlign: "right" }}>
                      <label className="form-label"></label>
                      <div className="search-box">
                        <input className="form-control search" placeholder="Search..." type="text"
                          name="search_key" onChange={(e) => setFormData(prev => ({ ...prev, search_key: e.target.value }))} value={formData.search_key} />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

          <div className="card-body pt-3">
            <div className="table-responsive table-card mb-1">
              <DataTable
                columns={columns}
                data={filteredRows}
                customStyles={customStyles}
                noHeader
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 50]}
                highlightOnHover
                persistTableHead
              />
            </div>

            {/* Expense modal for adding/editing an expense */}
            <ExpenseModal
              show={showExpenseModal}
              item={editExpense}
              onClose={() => { setShowExpenseModal(false); setEditExpense(null); }}
              onSaved={() => { setFormData(prev => ({ ...prev, page_no: 0 })); loadUsers(); }}
            />

            {/* render NewEmp with show/onClose props so edit reliably opens modal */}
            <NewEmp
              item={editItem}
              show={showModal}
              onClose={(refresh) => onNewEmpClose(refresh)}
              onAddDepart={() => { setFormData(prev => ({ ...prev, page_no: 0 })); loadUsers(); }}
            />

            {/* legacy hidden button retained for compatibility with older NewEmp implementations */}
            <button id="addbt453" style={{ display: 'none' }} type="button" className="btn btn-success add-btn" data-bs-toggle="modal" data-bs-target="#showModal"></button>

            <DelBox />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expense;
